import React, { FC } from 'react'
import { AnalyticsHeader } from '../AnalyticsHeader'
import Loader from '../../../components/common/loader/Loader'
import CertificationDetailOverviewTable from './CertificationDetailOverviewTable'
import {
  useCertificationDetailQuery,
  useCertificationRelatedCampaignsQuery
} from './CertificationDetail.codegen'
import { useParams } from 'react-router'
import { useHistory } from 'react-router-dom'
import { linkBuilder } from 'shared/linkBuilder'
import { t } from '@lingui/macro'
import { AnalyticsFiltersEnum } from '../constants'

interface IProps {
  showFilterPanel?: boolean
}

const CertificationDetail: FC<IProps> = ({ showFilterPanel }: IProps) => {
  const history = useHistory()
  const { certificationId } = useParams<{ certificationId: string }>()
  const { data, loading } = useCertificationDetailQuery({
    variables: {
      certificationId: +certificationId
    }
  })
  const {
    data: certificationRelatedCampaigns,
    refetch: loadCertificationRelatedCampaignsQuery
  } = useCertificationRelatedCampaignsQuery({
    variables: {
      certificationId: +certificationId
    },
    skip: true
  })

  const [relatedCampaigns, setRelatedCampaigns] = React.useState(
    certificationRelatedCampaigns?.campaigns ?? null
  )

  const loadCertificationRelatedCampaigns = React.useCallback(async () => {
    const { data } = await loadCertificationRelatedCampaignsQuery()
    const rc = data?.certification?.relatedCampaigns ?? []
    setRelatedCampaigns(rc)
    return rc
  }, [])

  if (loading) {
    return <Loader />
  }

  const certification = data?.certification
  if (!certification) {
    return null
  }

  return (
    <div className="PathwaysAnalyticsPage">
      <AnalyticsHeader
        goBack={history.goBack}
        showFilterPanel={showFilterPanel}
        link={linkBuilder.certificationsManage(certification.id)}
        linkHintText={t`Go to certification`}
        activeFilters={[
          AnalyticsFiltersEnum.INCLUDE_ARCHIVED,
          AnalyticsFiltersEnum.DATE_FILTER,
          AnalyticsFiltersEnum.INCLUDE_ADMINS,
          AnalyticsFiltersEnum.GROUP_FILTER,
          AnalyticsFiltersEnum.CAMPAIGN_FILTER
        ]}
        customLoadedEntities={{
          [AnalyticsFiltersEnum.CAMPAIGN_FILTER]: relatedCampaigns
        }}
        customDataLoaders={{
          [AnalyticsFiltersEnum.CAMPAIGN_FILTER]:
            loadCertificationRelatedCampaigns
        }}
      >
        <>{data?.certification?.name}</>
      </AnalyticsHeader>

      <CertificationDetailOverviewTable certificationId={+certificationId} />
    </div>
  )
}

export default CertificationDetail
